import { Twitch, Youtube, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { PlanetLogo } from "@/components/PlanetLogo";
import { FOOTER } from "@/content/galaxy";
import sponsorImg from "@/assets/sponsor-11teamsports.webp";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.1v12.4a2.6 2.6 0 1 1-2.3-2.58V9.6a5.7 5.7 0 1 0 5.4 5.7V9.01a7.3 7.3 0 0 0 4.05 1.23V7.13a4.28 4.28 0 0 1-2.99-1.31z" />
  </svg>
);

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const ICONS = {
  twitch: Twitch,
  youtube: Youtube,
  instagram: Instagram,
  tiktok: TikTokIcon,
  x: XIcon,
};

export const SiteFooter = () => {
  return (
    <footer className="relative z-10 mt-16 border-t border-white/10">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4 border-b border-white/5 pb-8 text-center">
          <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/45">
            Sponsor & Partner
          </span>
          <div
            aria-label="11Teamsports"
            data-testid="footer-sponsor-logo"
            className="inline-flex items-center rounded-xl bg-white px-5 py-3 shadow-[0_10px_34px_rgba(0,0,0,0.3)]"
          >
            <img
              src={sponsorImg}
              alt="11Teamsports"
              className="h-7 w-auto sm:h-9"
            />
          </div>
        </div>

        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2">
            <PlanetLogo className="h-6 w-6" />
            <span className="text-xs tracking-[0.14em] text-white/60">
              {FOOTER.copyright}
            </span>
          </div>

          <div className="flex items-center gap-3">
            {FOOTER.socials.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid="footer-social-link"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-white/65 transition-colors duration-200 hover:border-gl-blue/50 hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/5 pt-6">
          {FOOTER.legal.map((l) => {
            const isInternal = l.href.startsWith("/");
            const cls =
              "text-xs tracking-[0.14em] text-white/55 transition-colors duration-200 hover:text-white";
            return isInternal ? (
              <Link key={l.label} to={l.href} data-testid="footer-legal-link" className={cls}>
                {l.label}
              </Link>
            ) : (
              <a key={l.label} href={l.href} data-testid="footer-legal-link" className={cls}>
                {l.label}
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
};
